import { toast as notification } from 'react-toastify';

export const toast = (message, { variant = 'info' }) => notification[variant](message);
